import { useAtomValue } from "jotai";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useClient } from "#modules/clients/view/useClient";
import { useUpdateQuoteRequestClient } from "#modules/quoteRequests/view/useUpdateQuoteRequestClient";
import { ClientAtom, quoteRequestAtom } from "#shared/view/components/AppShell/Atoms";
import { EditLink } from "#shared/view/components/AppShell/EditLink";
import { SelectClientComboBox } from "#shared/view/components/AppShell/SelectClientComboBox";

export const QuoteRequestClient = ({ clientId }: { clientId: string | null }) => {
  const { t } = useTranslation();
  const quoteRequest = useAtomValue(quoteRequestAtom);
  const { updateQuoteRequestClient } = useUpdateQuoteRequestClient();
  const [isEditing, setIsEditing] = useState(false);

  const [currentClient, setCurrentClient] = useState<ClientAtom>({
    id: "",
    name: "",
  });

  const { client } = useClient(clientId ?? undefined);

  const initClient = useCallback(() => {
    if (client) {
      setCurrentClient({
        id: client.id || "",
        name: client.name || "",
      });
    } else {
      setCurrentClient({
        id: "",
        name: "",
      });
    }
  }, [client]);

  useEffect(() => {
    initClient();
  }, [initClient]);

  const saveClient = (selectedClient: ClientAtom) => {
    updateQuoteRequestClient({
      id: quoteRequest?.id || "",
      clientId: selectedClient?.id ?? "",
    });

    setIsEditing(false);
  };

  const cancelPendingEditing = () => {
    initClient();
    setIsEditing(false);
  };

  return (
    <>
      {!isEditing && (
        <EditLink
          defaultText={t("quoteRequestLine.clientName")}
          dataText={currentClient?.name}
          setIsEditing={setIsEditing}
        />
      )}

      {isEditing && (
        <SelectClientComboBox
          currentClient={currentClient}
          setCurrentClient={setCurrentClient}
          onCancel={cancelPendingEditing}
          onSaveClient={saveClient}
        />
      )}
    </>
  );
};
